module.exports = vendorsDll;